import styled from 'styled-components';
export const InterstitialTileTitle = styled.div.withConfig({
  displayName: "SharedComponents__InterstitialTileTitle",
  componentId: "sc-60hwiw-0"
})(["font-weight:600;font-size:20px;"]);